import { render } from "./houseTable.vue?vue&type=template&id=009704e8&scoped=true"
import script from "./houseTable.vue?vue&type=script&lang=js"
export * from "./houseTable.vue?vue&type=script&lang=js"

import "./houseTable.vue?vue&type=style&index=0&id=009704e8&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-009704e8"]])

export default __exports__